import { ProductSupplierPurchaseOrderDoc } from '@gooduncles/gu-app-schema';
import { Tabs } from 'antd';
import { FC, useState } from 'react';

import useProductSupplier from 'src/hooks/swr/useProductSupplier';

interface ProductSupplierPurchaseOrderViewProps {
  productSupplierPurchaseOrders: ProductSupplierPurchaseOrderDoc[];
}

const TabLabel: FC<{ productSupplierPurchaseOrder: ProductSupplierPurchaseOrderDoc }> = ({
  productSupplierPurchaseOrder,
}) => {
  const { productSupplier } = useProductSupplier(productSupplierPurchaseOrder.supplierId);
  return <span>{productSupplier?.name}</span>;
};

const ProductSupplierPurchaseOrderView: FC<ProductSupplierPurchaseOrderViewProps> = ({
  productSupplierPurchaseOrders,
}) => {
  const [index, setIndex] = useState(0);

  return (
    <Tabs
      type='card'
      defaultActiveKey={index.toString()}
      activeKey={index.toString()}
      style={{ overflow: 'hidden', height: '100%' }}
      tabBarStyle={{ marginBottom: 0 }}
      onChange={(key) => setIndex(Number(key))}
      items={productSupplierPurchaseOrders.map((productSupplierPurchaseOrder, idx) => ({
        label: <TabLabel productSupplierPurchaseOrder={productSupplierPurchaseOrder} />,
        key: idx.toString(),
        children: (
          <div className='tabBody'>
            <div>
              {productSupplierPurchaseOrder.messageRawList.map((message, idx) => (
                <p key={index + '-' + idx} className='front-dot'>
                  {message}
                </p>
              ))}
            </div>
          </div>
        ),
      }))}
    />
  );
};

export default ProductSupplierPurchaseOrderView;
